$(document).ready(() => {
    $([document.documentElement, document.body]).animate({
        scrollTop: 0
    }, 0);

    const currentUrl = TRNMNT_helpers.parseUrl();
    let page = currentUrl.params && currentUrl.params.gcp ? +currentUrl.params.gcp : 1;
    let tournament_mode = TOURNAMENT_MODE;
    let team_id = null;
    let user_id = null;
    let game_type = null;
    let tournament_id = TOURNAMENT_ID;
    let tournament_type = null;
    let division = null;
    let status = 'schedule';
    let prepend = false;

    const $itemsBlock = $('.match-items');
    const $lessGames = $('.match-filter-less_games').off().on('click', event => {
        event.preventDefault();
        if (page > 1) {
            page -= 1;
            TRNMNT_helpers.insertURLQueryParam('gcp', page);
            prepend = true;
            getGames();
        }
    });
    if (page > 1) {
        $lessGames.show();
    } else {
        $lessGames.hide();
    }
    const $moreGames = $('.match-filter-more_games').off().on('click', event => {
        event.preventDefault();
        page += 1;
        TRNMNT_helpers.insertURLQueryParam('gcp', page);
        prepend = false;
        getGames();
    });
    const $user = $('.match-filter-player').off().on('change', event => {
        user_id = event.target.value;
        TRNMNT_helpers.insertURLQueryParam('gcu', user_id);

        if (!user_id) {
            $division.show();
        } else {
            $division.hide();
            TRNMNT_helpers.deleteQueryParam('gcd');
        }

        page = 1;
        TRNMNT_helpers.deleteQueryParam('gcp');

        $itemsBlock.empty();
        getGames();
    });
    const $team = $('.match-filter-team').off().on('change', event => {
        team_id = event.target.value;
        TRNMNT_helpers.insertURLQueryParam('gct', team_id);

        if (!team_id) {
            $division.show();
        } else {
            $division.hide();
            TRNMNT_helpers.deleteQueryParam('gcd');
        }

        page = 1;
        TRNMNT_helpers.deleteQueryParam('gcp');

        $itemsBlock.empty();
        getGames();
    });
    const $gameType = $('.match-filter-game_type').off().on('change', event => {
        game_type = event.target.value;
        TRNMNT_helpers.insertURLQueryParam('gcgt', game_type);

        if (game_type === 'regular' && tournament_id) {
            $division.show();
        } else {
            $division.hide();
            TRNMNT_helpers.deleteQueryParam('gcd');
        }

        page = 1;
        TRNMNT_helpers.deleteQueryParam('gcp');

        $itemsBlock.empty();
        getGames();
    });
    const $tournament = $('.match-filter-tournament').off().on('change', event => {
        tournament_id = event.target.value;
        TRNMNT_helpers.insertURLQueryParam('gctr', tournament_id);

        if (game_type === 'regular' && tournament_id) {
            $division.show();
        } else {
            $division.hide();
            TRNMNT_helpers.deleteQueryParam('gcd');
        }

        page = 1;
        TRNMNT_helpers.deleteQueryParam('gcp');

        $itemsBlock.empty();
        getGames();
    });
    const $tournamentType = $('.match-filter-tournament-type').off().on('change', event => {
        tournament_type = event.target.value;
        TRNMNT_helpers.insertURLQueryParam('gctrt', tournament_type);

        page = 1;
        TRNMNT_helpers.deleteQueryParam('gcp');

        $itemsBlock.empty();
        getGames();
    });
    const $division = $('.match-filter-division').off().on('change', event => {
        division = event.target.value;
        TRNMNT_helpers.insertURLQueryParam('gcd', division);

        page = 1;
        TRNMNT_helpers.deleteQueryParam('gcp');

        $itemsBlock.empty();
        getGames();
    });
    const $gamesFilter = $('#gameStatusFilter li').on('click', event => {
        event.preventDefault();
        status = $(event.target).data('status');
        TRNMNT_helpers.insertURLQueryParam('gcs', status);

        page = 1;
        TRNMNT_helpers.deleteQueryParam('gcp');

        $itemsBlock.empty();
        getGames();
    });
    const $tournamentMode = $('#tournamentMode input').off().on('change', event => {
        tournament_mode = event.target.value;
        TRNMNT_helpers.insertURLQueryParam('gctm', tournament_mode);

        $user.val('');
        user_id = null;
        TRNMNT_helpers.deleteQueryParam('gcu');

        $team.val('');
        team_id = null;
        TRNMNT_helpers.deleteQueryParam('gct');

        $gameType.val('');
        game_type = null;
        TRNMNT_helpers.deleteQueryParam('gcgt');

        $tournament.val('');
        tournament_id = TOURNAMENT_ID;
        TRNMNT_helpers.deleteQueryParam('gctr');

        $tournamentType.val('all');
        tournament_type = null;
        TRNMNT_helpers.deleteQueryParam('gctrt');

        $division.val('');
        division = null;
        TRNMNT_helpers.deleteQueryParam('gcd');

        status = 'schedule';
        $gamesFilter.children('button').removeClass('active');
        $('#' + status + '-tab').addClass('active');
        TRNMNT_helpers.deleteQueryParam('gcs');

        page = 1;

        $itemsBlock.empty();
        getGames();
    });

    if (currentUrl.params) {
        if (currentUrl.params.gctm) {
            $tournamentMode.val(currentUrl.params.gcu);
            tournament_mode = currentUrl.params.gctm;
        }
        if (currentUrl.params.gcu) {
            $user.val(currentUrl.params.gcu);
            user_id = currentUrl.params.gcu;
        }
        if (currentUrl.params.gct) {
            $team.val(currentUrl.params.gct);
            team_id = currentUrl.params.gct;
        }
        if (currentUrl.params.gcgt) {
            $gameType.val(currentUrl.params.gcgt);
            game_type = currentUrl.params.gcgt;
        }
        if (currentUrl.params.gctr) {
            $tournament.val(currentUrl.params.gctr);
            tournament_id = currentUrl.params.gctr;
        }
        if (currentUrl.params.gctrt) {
            $tournamentType.val(currentUrl.params.gctrt);
            tournament_type = currentUrl.params.gctrt;
        }
        if (currentUrl.params.gcd) {
            $division.val(currentUrl.params.gcd);
            division = currentUrl.params.gcd;
        }
        if (currentUrl.params.gcs) {
            status = currentUrl.params.gcs;
            $gamesFilter.find('button').removeClass('active');
            $gamesFilter.find(`button[data-status=${status}]`).addClass('active');
        }
    }

    getGames();

    function getGames() {
        const data = {
            page: page,
        };
        if (user_id) {
            data.user_id = user_id;
        }
        if (team_id) {
            data.team_id = team_id;
        }
        if (game_type) {
            data.game_type = game_type;
        }
        if (tournament_id) {
            data.tournament_id = tournament_id;
        }
        if (tournament_type) {
            data.tournament_type = tournament_type;
        }
        if (!team_id && !user_id && division && tournament_id && game_type === 'regular') {
            data.division = division;
        }
        if (status && ['schedule', 'results'].indexOf(status) !== -1) {
            data.status = status;
        }

        if (page === 1) {
            $lessGames.hide();
            $moreGames.show();
        }
        $('.match-filter-no_games').hide();
        TRNMNT_helpers.disableButtons();

        $.ajax({
            headers: {
                'X-CSRF-TOKEN': $('meta[name="csrf-token"]').attr('content')
            },
            type: 'get',
            url: (tournament_mode === 'group' ? GROUP_GAMES_URL : VERSUS_GAMES_URL) + '?' + jQuery.param(data),
            processData: false,
            success: response => {
                // const $lastBlock = $('.match-items .match-card').last();
                // if ($lastBlock.length) {
                //     $([document.documentElement, document.body]).animate({
                //         scrollTop: $lastBlock.offset().top
                //     }, 0);
                // }

                if (prepend) {
                    for (let i = response.data.length - 1; i >= 0; i -= 1) {
                        const $block = TRNMNT_helpers.createGameBlock(response.data[i]);
                        $itemsBlock.prepend($block);
                    }
                } else {
                    for (let game of response.data) {
                        const $block = TRNMNT_helpers.createGameBlock(game);
                        $itemsBlock.append($block);
                    }
                }

                if ($itemsBlock.children().length === response.recordsTotal) {
                    $moreGames.hide();
                }

                if (page === 1 && response.recordsTotal === 0) {
                    $('.match-filter-no_games').show();
                }
                TRNMNT_helpers.enableButtons();
            },
            error: TRNMNT_helpers.onErrorAjax,
            context: TRNMNT_helpers
        });
    }
});
